/**
 * SearchResults component.
 */
import Content from '@components/elements/search/searchContent';
import Description from '@components/elements/search/searchDescription';
import Message from '@components/atoms/text/searchMessage';

/**
 * SearchResults component props.
 */
interface Props {
  message: string;
  searching: boolean;
}

export default function SearchResults({ message, searching }: Props) {
  return (
    <>
      {!searching ? <Content /> : <></>}
      <Description />
      {message ? <Message searching={searching}>{message}</Message> : null}
    </>
  );
}
